export const BASE_URL = "https://mental-test-backend-813223978810.me-central1.run.app";
// export const BASE_URL = "https://soc-constant-oak-search.trycloudflare.com";
